<template>
  <div id="vue-circle-container">
    <vue-circle
      v-if="size != 0"
      ref="circle"
      :size="size"
      :progress="0"
      :reverse="false"
      line-cap="round"
      :fill="{ gradient: ['yellow', 'cyan'] }"
      empty-fill="rgba(0, 0, 0, .1)"
      :animation-start-value="0.0"
      :start-angle="11"
      insert-mode="append"
      :thickness="5"
      :show-percent="true">
      <p>Booked</p>
    </vue-circle>
  </div>
</template>

<script>
  import VueCircle from 'vue2-circle-progress'

  export default {
    components: {
      VueCircle
    },
    props: [
      'utilization',
    ],

    data() {
      return {
        size: 0
      }
    },

    watch: {
      utilization: function () {
        this.$refs.circle.updateProgress(this.utilization)
      }
    },

    mounted() {
      this.size = 0.9 * document.querySelector('#vue-circle-container').parentElement.clientWidth
      this.$nextTick(() => {
        this.$refs.circle.updateProgress(this.utilization || 0)
      })
    },
  }
</script>



// WEBPACK FOOTER //
// src/views/reports/TotalUtilization.vue